import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { movies } from '@/mocks/movies';

const heroMovies = movies.filter((m) => m.isHot && m.rating >= 9.0).slice(0, 4);

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % heroMovies.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const currentMovie = heroMovies[current];

  return (
    <section className="relative h-[420px] md:h-[600px] w-full overflow-hidden">
      {heroMovies.map((movie, index) => (
        <div
          key={movie.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === current ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={movie.coverImage}
            alt={movie.title}
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background-50"></div>

      <div className="absolute inset-0 flex items-center">
        <div className="container-site w-full">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/20 border border-primary-500/30 mb-4">
              <i className="ri-fire-line text-primary-400 text-sm"></i>
              <span className="text-xs text-primary-300 font-medium">热播推荐</span>
            </div>
            <h1 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 mb-3">
              {currentMovie.title}
            </h1>
            <div className="flex items-center gap-3 mb-4 flex-wrap">
              <span className="flex items-center gap-1 text-accent-400 text-sm">
                <i className="ri-star-fill text-xs"></i>
                {currentMovie.rating}
              </span>
              <span className="text-foreground-400 text-sm">{currentMovie.year}</span>
              <span className="text-foreground-400 text-sm">{currentMovie.category}</span>
              <span className="text-foreground-400 text-sm">{currentMovie.duration}</span>
              {currentMovie.type === 'tv' && (
                <span className="px-2 py-0.5 text-xs bg-secondary-500/30 text-secondary-300 rounded">电视剧</span>
              )}
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed mb-6 line-clamp-2 md:line-clamp-3">
              {currentMovie.description}
            </p>
            <div className="flex items-center gap-3">
              <Link
                to={`/detail/${currentMovie.id}`}
                className="btn-primary cursor-pointer"
              >
                <i className="ri-play-fill mr-2"></i>
                立即观看
              </Link>
              <Link
                to={`/category/${currentMovie.categorySlug}`}
                className="inline-flex items-center justify-center px-6 py-3 rounded-md font-medium text-sm whitespace-nowrap cursor-pointer transition-all duration-300 border border-foreground-300/30 text-foreground-700 hover:bg-foreground-100/10"
              >
                更多{movies.find((m) => m.category === currentMovie.category)?.category}
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-0 right-0">
        <div className="container-site flex items-center justify-center gap-2">
          {heroMovies.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrent(index)}
              className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                index === current
                  ? 'w-6 bg-primary-500'
                  : 'bg-foreground-400/50 hover:bg-foreground-400'
              }`}
              aria-label={`切换到第${index + 1}张`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}